import { useState, useCallback, useEffect } from 'react'
import taskService from '../services/tasks/taskService'
import { showSuccessToast } from '../helpers/toast'

export default function useTask(taskId) {
  const [task, setTask] = useState(null)
  const [loading, setLoading] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)

  const fetchTask = useCallback(async () => {
    if (!taskId) return
    setLoading(true)
    try {
      const response = await taskService.getTaskById(taskId)
      setTask(response.data)
    } catch {
      setTask(null)
    } finally {
      setLoading(false)
    }
  }, [taskId])

  useEffect(() => {
    fetchTask()
  }, [fetchTask])

  const acceptTask = useCallback(async () => {
    setActionLoading(true)
    try {
      await taskService.acceptTask(taskId)
      showSuccessToast('Detyra u pranua.')
      await fetchTask()
    } finally {
      setActionLoading(false)
    }
  }, [taskId, fetchTask])

  const refuseTask = useCallback(async (comment) => {
    setActionLoading(true)
    try {
      await taskService.refuseTask(taskId, comment)
      showSuccessToast('Detyra u refuzua.')
      await fetchTask()
    } finally {
      setActionLoading(false)
    }
  }, [taskId, fetchTask])

  const completeTask = useCallback(async () => {
    setActionLoading(true)
    try {
      await taskService.completeTask(taskId)
      showSuccessToast('Detyra u perfundua.')
      await fetchTask()
    } finally {
      setActionLoading(false)
    }
  }, [taskId, fetchTask])

  const completeTaskPartially = useCallback(async () => {
    setActionLoading(true)
    try {
      await taskService.completeTaskPartially(taskId)
      showSuccessToast('Detyra u mbyll pjeserisht.')
      await fetchTask()
    } finally {
      setActionLoading(false)
    }
  }, [taskId, fetchTask])

  const markSeen = useCallback(async () => {
    try {
      await taskService.setTaskSeen(taskId)
    } catch {
      // silent
    }
  }, [taskId])

  return {
    task,
    loading,
    actionLoading,
    refresh: fetchTask,
    acceptTask,
    refuseTask,
    completeTask,
    completeTaskPartially,
    markSeen,
  }
}
